<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    append-to-body
    title="选择"
    width="900px"
    top="5vh"
  >
    <TableSelect :filter="filter" :columns="columns" module="basic" url="system/user" @select="selectUser">
      <template slot="adSearch">
        <el-form :inline="true" :model="filter">
          <el-form-item label="用户名">
            <el-input v-model.trim="filter.userName" placeholder="请输入用户名" clearable />
          </el-form-item>
          <el-form-item label="用户姓名">
            <el-input v-model.trim="filter.employeeName" placeholder="请输入用户姓名" clearable />
          </el-form-item>
        </el-form>
      </template>
    </TableSelect>
  </el-dialog>
</template>

<script>
import TableSelect from "@/components/TableSelect.vue";

export default {
  components: { TableSelect },
  data() {
    return {
      dialogVisible: false,
      filter: {},
      columns: [
        {
          title: "用户名",
          key: "userName",
          width: 120,
          align: "center",
        },
        {
          title: "用户类型",
          key: "userTypeName",
          width: 120,
          align: "center",
        },
        {
          title: "姓名",
          key: "employeeName",
          width: 120,
          align: "center",
        },
        {
          title: "员工编号",
          key: "employeeNo",
          width: 100,
          align: "center",
        },
        {
          title: "所属部门",
          key: "departmentName",
          minWidth: 200,
        },
        {
          title: "操作",
          slot: "action",
          width: 80,
          align: "center",
        },
      ],
    };
  },
  methods: {
    open() {
      this.dialogVisible = true;
    },

    selectUser(row) {
      this.$emit("select", row);
      this.dialogVisible = false;
    },
  },
};
</script>
